(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
var loadComplementaryProducts = function() {
  var wrapper = document.querySelector('.product-complementary');
  if (!wrapper) { return; }
  var grid = wrapper.querySelector('[data-comp-grid]');
  if (!grid) { return; }
  var limit = parseInt(wrapper.dataset.limit, 10) || 4;
  wrapper.dataset.compInit = '';

  var showAll = function() {
    var heading = wrapper.querySelector('[data-comp-heading]');
    var wrap = wrapper.querySelector('[data-comp-wrap]');
    if (heading) { heading.style.display = ''; }
    if (wrap) { wrap.style.display = ''; }
  };
  var initCarousel = function() {
    if (wrapper.dataset.compInit === '1' || !grid.children.length) { return; }
    wrapper.dataset.compInit = '1';
    try {
      theme.peekCarousel.init(
        wrapper,
        $('.js-related-product-carousel', wrapper),
        '.productRecommendations',
        function() { return $(window).width() < 768; },
        false
      );
      theme.initUniformHeightMonitor(wrapper, '.product-block__image-container', '.product-block__image-container .image-one');
    } catch (e) {}
  };
  var finish = function() {
    if (grid.children.length) { showAll(); initCarousel(); }
  };

  if (grid.children.length >= limit) { finish(); return; }

  var productId = wrapper.dataset.productId;
  var sectionId = wrapper.dataset.sectionId;
  if (!sectionId || !productId) { finish(); return; }

  var requestUrl = wrapper.dataset.url + '?section_id=' + encodeURIComponent(sectionId) + '&limit=10&product_id=' + productId + '&intent=related';
  var request = new XMLHttpRequest();
  request.open('GET', requestUrl);
  request.onload = function() {
    try {
      if (request.status >= 200 && request.status < 300) {
        var tmp = document.createElement('div');
        tmp.innerHTML = request.response;
        var cards = tmp.querySelectorAll('.js-filler-source .product-block');
        var seen = {};
        var existing = grid.querySelectorAll('a.product-block__image');
        for (var i = 0; i < existing.length; i++) {
          seen[existing[i].getAttribute('href').split('?')[0]] = true;
        }
        var selfPath = (wrapper.dataset.selfUrl || '').split('?')[0];
        for (var j = 0; j < cards.length && grid.children.length < limit; j++) {
          var link = cards[j].querySelector('a.product-block__image');
          if (!link) { continue; }
          var path = link.getAttribute('href').split('?')[0];
          if (seen[path] || path === selfPath) { continue; }
          seen[path] = true;
          grid.appendChild(cards[j]);
        }
      }
    } catch (e) {}
    finish();
  };
  request.onerror = finish;
  request.send();
};
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector && event.target.querySelector('.product-complementary')) {
    loadComplementaryProducts();
  }
});
document.addEventListener('shopify:section:unload', function(event) {
  if (event.target.querySelector && event.target.querySelector('.product-complementary')) {
    try {
      theme.destroyUniformHeightMonitor($('.product-complementary', event.target));
      theme.peekCarousel.destroy(
        $('.product-complementary', event.target),
        $('.js-related-product-carousel', event.target),
        '.productRecommendations'
      );
    } catch (e) {}
  }
});
document.addEventListener('DOMContentLoaded', function() {
  loadComplementaryProducts();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Read this section's id (changes in JSON templates)
  var sectionId = productRecommendationsSection.dataset.sectionId || 'product-recommendations';
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url + '?section_id=' + encodeURIComponent(sectionId) + '&limit=' + limit + '&product_id=' + productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var loaded = container.querySelector(".product-recommendations");
      if (loaded === null) { return; }
      productRecommendationsSection.innerHTML = loaded.innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
      theme.initUniformHeightMonitor(productRecommendationsSection, '.product-block__image-container', '.product-block__image-container .image-one');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (event.target.querySelector && event.target.querySelector('.product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (event.target.querySelector && event.target.querySelector('.product-recommendations')) {
    theme.destroyUniformHeightMonitor($('.product-recommendations', event.target));
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
